import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../components/molecules/Dropdown';
import useContextEnvs from '../hooks/useContextEnvs';
import { CONTEXT_PROD_MODE } from '../constants';
import css from './ContextEnvSelect.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.CONTEXT_ENV';

// Dropdown translates string labels; a branch name has no key, so it falls through as itself.
const LOADING_ITEM = { name: '__loading__', display_name: `${TRANSLATION_PREFIX}.LOADING`, disabled: true };
const LOAD_FAILED_ITEM = { name: '__load_failed__', display_name: `${TRANSLATION_PREFIX}.LOAD_FAILED`, disabled: true };

const toItem = env => ({ name: env, display_name: env === CONTEXT_PROD_MODE ? `${TRANSLATION_PREFIX}.PROD` : env });

const ContextEnvSelect = ({ selectedEnv, onChange }) => {
    const { envs, loading, failed } = useContextEnvs();
    const items = useMemo(() => {
        const status = (loading && LOADING_ITEM) || (failed && LOAD_FAILED_ITEM);
        return [...envs.map(toItem), ...(status ? [status] : [])];
    }, [envs, loading, failed]);

    return (
        <Dropdown
            id="context-env-select"
            items={items}
            selected={toItem(selectedEnv)}
            onSelection={item => onChange(item.name)}
            placement="bottom-start"
            wrapperClass={css.wrapper}
            containerClass={css.trigger}
            bodyClassName={css.menuBody}
        />
    );
};

ContextEnvSelect.propTypes = {
    selectedEnv: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ContextEnvSelect;
